export default "__VITE_ASSET__sA2OZABN__"